export default __webpack_public_path__ + "static/media/dashboard.75e4f698.png";